import { useState } from "react"
import { Button, Card, CardBody } from "reactstrap"
import StockImagesUpdate from "./StockImagesUpdate"
import ThemePlaceholder from "components/Common/ThemePlaceholder"
import ButtonTooltip from "components/Common/ButtonTooltip"
import ImageViewer from "components/Common/ImageViewer/ImageViewer"

export default function ImageGallery({
  stock,
  carImages = [],
  loading = false,
}) {
  const [activeImage, setActiveImage] = useState(0)

  const [viewerOpen, setViewerOpen] = useState(false)
  const [selectedImageIndex, setSelectedImageIndex] = useState(0)
  const [selectedImageUrls, setSelectedImageUrls] = useState("")
  const [imageTitle, setImageTitle] = useState("Auction Sheet")

  const openImageViewer = urls => {
    setSelectedImageIndex(0)
    setViewerOpen(true)
    setSelectedImageUrls(urls || "")
  }

  return (
    <Card className="border-0 shadow-sm mb-4">
      <CardBody className="p-3">
        <div
          className="main-image rounded"
          style={{ backgroundColor: "#f8f9fa", minHeight: 200 }}
        >
          {loading ? (
            <ThemePlaceholder
              style={{ width: "100%", height: 200, borderRadius: 6 }}
            />
          ) : (
            <img
              src={carImages[activeImage]}
              alt={`${stock?.brand?.name} ${stock?.model?.name}`}
              className="w-100 h-100 object-fit-cover rounded"
            />
          )}
        </div>

        <div className="d-flex mt-3 justify-content-center flex-wrap">
          {loading
            ? Array.from({ length: 4 }).map((_, idx) => (
                <ThemePlaceholder
                  key={idx}
                  style={{
                    width: 70,
                    height: 50,
                    borderRadius: 6,
                    margin: "0 4px",
                  }}
                />
              ))
            : carImages.map((img, index) => (
                <div
                  key={index}
                  className={`thumbnail mx-1 ${
                    activeImage === index ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveImage(index)
                    openImageViewer([img, ...carImages])
                  }}
                  style={{
                    width: "70px",
                    height: "50px",
                    cursor: "pointer",
                    opacity: activeImage === index ? 1 : 0.7,
                    border:
                      activeImage === index
                        ? "3px solid #4a6cf7"
                        : "1px solid #dee2e6",
                    borderRadius: "6px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={img}
                    alt={`Thumbnail ${index + 1}`}
                    className="w-100 h-100 object-fit-cover"
                  />
                </div>
              ))}
        </div>

        {!loading && (
          <div className="d-flex justify-content-end">
            <StockImagesUpdate stock={stock} />
          </div>
        )}
        {!!stock?.auction_sheet?.url && (
          <div className="text-center">
            <ButtonTooltip
              type="view"
              btnId={`view-auction-sheet`} // unique ID for tooltip
              btnName={" Auction Sheet"}
              onClick={() => openImageViewer([stock.auction_sheet.url])}
              is_label={true}
            />
          </div>
        )}
        {/* Image Viewer Modal */}
        <ImageViewer
          images={selectedImageUrls ?? []}
          initialIndex={selectedImageIndex}
          isOpen={viewerOpen}
          onClose={() => setViewerOpen(false)}
          title={imageTitle}
        />
      </CardBody>
    </Card>
  )
}
